import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER TODAS LAS PRIORIDADES
export const obtenerPrioridades = async () => {
  const respuesta = await PrivateInterceptor(`Base/Global/Prioridades`, "GET");
  return respuesta;
};

// OBTENER TODAS LAS PRIORIDADES
export const obtenerPrioridadesAct = async (PriorityCategory) => {
  const respuesta = await PrivateInterceptor(`Base/Global/Prioridades/PrioridadesAct/${PriorityCategory}`, "GET");
  return respuesta;
};

// AGREGAR PRIORIDAD
export const agregarPrioridades = async (data) => {
  const respuesta = await PrivateInterceptor(
    `Base/Global/Prioridades/add`,
    "POST",
    data
  );
  return respuesta;
};
